import { FormValues, FormErrors } from './hooks';

export default function handleValidation(formValues: FormValues) {
    const formErrors: FormErrors = {};

    if (formValues.usernameDirty && !formValues.username?.trim()) {
        formErrors.username = {
            text: 'Username required',
            type: 'warning',
        };
    }

    if (formValues.passwordDirty && formValues.password?.length === 0) {
        formErrors.password = {
            text: 'Password required',
            type: 'warning',
        };
    }

    return formErrors;
}
